import React from 'react';
import "./home.css";
import Me from "../../assets/fundinColorido.png"
import HeaderSocials from './HeaderSocials';
import ScrollDown from './ScrollDown';
import Shapes from './Shapes';
import {useTypewriter, Cursor} from 'react-simple-typewriter';
import { useLanguage } from '../../context/LanguageContext';

const Home = () => {
  
  const { translations } = useLanguage();

  const[textName] = useTypewriter({
    words: ['Glória Braz', 'Lívia Braz'],
    loop: {},
    typeSpeed: 120,
    deleteSpeed: 100,
  });

  return (
    <section className="home container" id="home">
      <div className="intro"> 
        <img src={Me} alt="" className="home__img" />
        <h1 className="home__name"> {textName} <Cursor /> </h1>
        <h1>{translations.careerTitle}</h1>
        <span className="home__education">{translations.quoteMessage}</span>
        
      <HeaderSocials />

      <a href="#contact" className="btn">{translations.contactMe}</a>

      <ScrollDown />
      </div>

      <Shapes />
    </section>
  )
}

export default Home